"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = triggerOne;

var _defs = _interopRequireDefault(require("../_core/defs"));

var _apply = _interopRequireDefault(require("../_helpers/apply"));

// triggers one event
function triggerOne(object, name, triggerArgs) {
  var def = _defs["default"].get(object);

  var events = def && def.events[name];

  if (events) {
    var l = events.length;
    var i = 0; // allow to pass both array of args and single arg as triggerArgs

    if (triggerArgs instanceof Array) {
      while (i < l) {
        var event = triggerOne.latestEvent = events[i];
        var callback = event.callback,
            ctx = event.ctx;
        (0, _apply["default"])(callback, ctx, triggerArgs);
        i += 1;
      }
    } else {
      while (i < l) {
        var _event = triggerOne.latestEvent = events[i];

        var _callback = _event.callback,
            _ctx = _event.ctx;

        _callback.call(_ctx, triggerArgs);

        i += 1;
      }
    }
  }
} // latestEvent is used as required hack in somemethods


triggerOne.latestEvent = {
  info: {},
  name: null
};
//# sourceMappingURL=_triggerone.js.map